import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH MAIN_ITEM PRODUCTS ********************
export const fetchMainProducts = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_MAIN_ITEM_PRODUCTS_LOADING,
			payload: true
		});

		const { data } = await services.get(`/packet/${id}/products`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_MAIN_ITEM_PRODUCTS_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_MAIN_ITEM_PRODUCTS_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
